module.exports = __webpack_public_path__ + "static/man-tablet.bca477bc.jpg";